import type { Workspace } from '@/api/generated/schemas.ts';
import Avatar, { type AvatarProps } from '@/core/components/Avatar.tsx';

export interface WorkspaceAvatarProps extends Omit<AvatarProps, 'name' | 'hue' | 'src'> {
    workspace: Pick<Workspace, 'name' | 'color_hue' | 'logo_url'>;
}

const WorkspaceAvatar = ({ workspace, ...props }: WorkspaceAvatarProps) => (
    <Avatar {...props} name={workspace.name} hue={workspace.color_hue} src={workspace.logo_url ?? undefined} />
);

export default WorkspaceAvatar;
